import {SummaryModel} from "../../../../../common/entity/summary.model";
import {PermissionsModel} from "../../../../../common/entity/permissions.model";
import {Moment} from "moment";
import {LovValueSummary} from "../../../../../common/lov/lov-value/api/model/lovValueSummary.model";

export class ProductStockUnitSummaryModel implements SummaryModel {
    id: number;
    permissions: PermissionsModel;
    productName: string;
    batchNumber: string;
    entryDate: Moment;
    exitDate: Moment;
    color: LovValueSummary;
    partiallyUsed: boolean;
    beingUsed: boolean;

    get available(): boolean {
        return !this.exitDate;
    }
}
